import { Modal as NextUIModal, ModalProps } from "@heroui/react";

export const Modal = NextUIModal;
export type { ModalProps };